import { KEY_PREFIX } from 'redux-persist/lib/constants';
import { crossTabSyncAuthActionCreator } from 'plugins/store/reducers/auth.reducer';

const crossTabSync = (store, crossTabConfig = {}) => {
	const blacklist = crossTabConfig.blacklist || null;
	const whitelist = crossTabConfig.whitelist || null;
	const keyPrefix = crossTabConfig.keyPrefix || KEY_PREFIX;

	window.addEventListener('storage', handleStorageEvent, false);

	function handleStorageEvent(e) {
		if (e.key && e.key.indexOf(keyPrefix) === 0) {
			if (e.oldValue === e.newValue) {
				return;
			}
			const statePartial = JSON.parse(e.newValue);

			const state = Object.keys(statePartial).reduce((state, reducerKey) => {

				if (whitelist && whitelist.indexOf(reducerKey) === -1) {
					return state;
				}

				if (blacklist && blacklist.indexOf(reducerKey) !== -1) {
					return state;
				}

				state[reducerKey] = JSON.parse(statePartial[reducerKey]);
				return state;
			}, {});

			store.dispatch(crossTabSyncAuthActionCreator(state));
		}
	}
};

export default crossTabSync;